import { useRef } from 'react';
import { Link } from 'react-router-dom';
import useScrollReveal from '@/hooks/useScrollReveal';
import cta from '@/assets/cta.jpg'

const CTABanner = () => {
  const ref = useRef<HTMLDivElement>(null);
  useScrollReveal(ref);

  return (
    <section ref={ref} className="bg-byellow overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-12 items-center">

          {/* Left: content */}
          <div>
            <div data-reveal data-delay="1" className="mb-5">
              <span className="text-[11px] font-bold text-ink/40 tracking-widest uppercase">04 — Join the Movement</span>
            </div>

            <h2 data-reveal data-delay="2" className="text-4xl md:text-5xl font-bold text-ink leading-[1.08] tracking-tight mb-5">
              Be part of Bihar&apos;s<br />Ethanol Story
            </h2>

            <p data-reveal data-delay="3" className="text-ink/60 text-base leading-relaxed mb-9 max-w-lg">
              Whether you&apos;re a manufacturer, policymaker, investor, or researcher — connect with BEA to access resources, build partnerships, and shape the future of Bihar&apos;s ethanol sector.
            </p>

            <div data-reveal data-delay="4" className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-ink text-white font-semibold text-sm hover:bg-ink-light transition-colors duration-150 whitespace-nowrap cursor-pointer"
              >
                Connect With BEA
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm" /></span>
              </Link>
              <button
                onClick={() => alert('Coming Soon!')}
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md border border-ink/20 text-ink font-medium text-sm hover:bg-ink/5 transition-colors duration-150 whitespace-nowrap cursor-pointer"
              >
                View Manufacturers
              </button>
            </div>
          </div>

          {/* Right: image — scale in */}
          <div data-reveal="scale" data-delay="2" className="hidden lg:block">
            <div className="relative overflow-hidden rounded-lg" style={{ height: '320px' }}>
              <img
                src={cta}
                alt="Bihar Sugarcane Harvest"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute right-0 top-0 bottom-0 w-1 bg-bteal" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
